import { render, staticRenderFns } from "./TarotShuffle.vue?vue&type=template&id=71123cf4&"
import script from "./TarotShuffle.vue?vue&type=script&lang=js&"
export * from "./TarotShuffle.vue?vue&type=script&lang=js&"
import style0 from "./TarotShuffle.vue?vue&type=style&index=0&id=71123cf4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports